import React from 'react';
import './styles.scss';

function GuggenInvitees() {
    const groups = [
        {
            key: 'peinsaclick',
            name: 'Peinsâclicks',
            cowImage: require('../../assets/images/guggen/vachePeinsaclick.png'),
            photoImage: require('../../assets/images/guggen/Peinsaclick.jpeg'),
            description: "Les Peinsâclicks sont nés à Hérémence après une soirée entre copains autour d’un verre de blanc. Leur nom vient du patois “peinsa” (mangeurs de soupe) + “clicks” (guggen en suisse-allemand). Fondés officiellement le 18 décembre 1999, ils ont commencé aux percussions, puis ont ajouté les cuivres en 2001, avant d’animer surtout des carnavals en Valais avec quelques sorties et moments marquants (drapeau, costumes, anniversaires).",
        },
        {
            key: 'nuctambols',
            name: "Les Nuctambol's",
            cowImage: require('../../assets/images/guggen/vacheNuctambols.png'),
            photoImage: require('../../assets/images/guggen/Nuctambols.jpeg'),
            description: "Les Nuctambol's sont une guggenmusik suisse basée à Vétroz, fondée en 1966 et réputée pour sa passion et son dynamisme. Ce groupe de carnaval anime des festivités en Valais, perpétuant une tradition festive et musicale avec des prestations scéniques énergiques. Ils célèbrent leur histoire, marquée par des anniversaires comme leurs 30 ans.",
            invertImages: true,
        },
        {
            key: 'chenegaudes',
            name: 'Les Chenegaudes',
            cowImage: require('../../assets/images/guggen/vacheChenegaudes.png'),
            photoImage: require('../../assets/images/guggen/Chenegaudes.png'),
            description: "Nés en 1994 à Saint-Martin (14 jeunes), les Chenegaudes incarnent l’esprit des bons vivants valaisans. Devenus une grande famille à travers tout le Valais, ils ont marqué leurs 10 ans (2004) avec des costumes aux couleurs feu, puis leurs 30 ans (2024) avec une grande fête et de nouveaux costumes. Depuis, ils mettent le feu aux carnavals en Valais et au-delà.",
        },
    ];

    return (
        <section className="tf-section guggen-invitees">
            <div className="container w_1490">
                <div className="tf-title center" data-aos="fade-up" data-aos-duration="800">
                    <h2 className="title mb20">Guggen invitées</h2>
                    <p className="text">Découvrez les guggen invitées de cette édition.</p>
                </div>

                <div className="guggen-list">
                    {groups.map((group, idx) => (
                        <div className="guggen-item" key={group.key} data-aos="fade-up" data-aos-duration="800" data-aos-delay={idx * 100}>
                            <div className="row align-items-center">
                                <div className={`col-lg-6 col-md-12 ${idx % 2 === 1 ? 'order-lg-2' : 'order-lg-1'}`}>
                                    <div className="guggen-images">
                                        {group.invertImages ? (
                                            <>
                                                {group.photoImage ? (
                                                    <img className="guggen-photo" src={group.photoImage} alt={group.name} loading="lazy" />
                                                ) : (
                                                    <div className="guggen-photo-placeholder">Photo à ajouter</div>
                                                )}
                                                <img className="guggen-cow" src={group.cowImage} alt={`Vache ${group.name}`} loading="lazy" />
                                            </>
                                        ) : (
                                            <>
                                                <img className="guggen-cow" src={group.cowImage} alt={`Vache ${group.name}`} loading="lazy" />
                                                {group.photoImage ? (
                                                    <img className="guggen-photo" src={group.photoImage} alt={group.name} loading="lazy" />
                                                ) : (
                                                    <div className="guggen-photo-placeholder">Photo à ajouter</div>
                                                )}
                                            </>
                                        )}
                                    </div>
                                </div>
                                <div className={`col-lg-6 col-md-12 ${idx % 2 === 1 ? 'order-lg-1' : 'order-lg-2'}`}>
                                    <div className="guggen-content">
                                        <h3 className="guggen-name">{group.name}</h3>
                                        <div className="guggen-text-box">
                                            <p className="text">{group.description ?? 'Texte à ajouter (présentation, origine, horaires, etc.).'}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}

export default GuggenInvitees;
